export default "__VITE_ASSET__0r40mytT__"